module.exports = __webpack_public_path__ + "img/next@2x.56b9c3d4.png";